import { render, staticRenderFns } from "./LiveManage.vue?vue&type=template&id=3e7c577a&scoped=true"
import script from "./LiveManage.vue?vue&type=script&lang=js"
export * from "./LiveManage.vue?vue&type=script&lang=js"
import style0 from "./LiveManage.vue?vue&type=style&index=0&id=3e7c577a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7c577a",
  null
  
)

export default component.exports